import React from 'react';
import { Bell, Search } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

export default function Header({ title, subtitle }) {
  const { admin } = useAuth();
  return (
    <div className="bg-white border-b border-gray-100 px-6 py-4 flex items-center justify-between">
      <div>
        <h1 className="text-xl font-black text-gray-900">{title}</h1>
        {subtitle && <p className="text-sm text-gray-500 mt-0.5">{subtitle}</p>}
      </div>
      <div className="flex items-center gap-3">
        <div className="relative hidden md:block">
          <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
          <input type="text" placeholder="Quick search..." className="pl-8 pr-4 py-2 text-sm border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-400 w-48" />
        </div>
        <button className="relative w-9 h-9 bg-gray-50 rounded-xl flex items-center justify-center hover:bg-orange-50 transition-colors">
          <Bell size={17} className="text-gray-600" />
          <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-orange-500 rounded-full" />
        </button>
        <img src={admin?.avatar || `https://ui-avatars.com/api/?name=${encodeURIComponent(admin?.full_name || 'Admin')}&background=f3700e&color=fff`}
          alt="Admin" className="w-9 h-9 rounded-xl object-cover" />
      </div>
    </div>
  );
}
